export const highlightMatch = (term: string, query: string, highLightClassName = 'bg-yellow-400') => {
  const index = term.toLowerCase().indexOf(query.toLowerCase());
  if (index === -1) return term;
  return (
    <span>
      {term.slice(0, index)}
      <span className={highLightClassName}>{term.slice(index, index + query.length)}</span>
      {term.slice(index + query.length)}
    </span>
  );
};

export function highlightMatchingWordPrefixes(term: string | undefined, query: string | undefined) {
  const safeTerm = (term ?? "").trim();

  if (safeTerm.length === 0) return [];

  const safeQuery = (query ?? "").trim();

  if (safeQuery.length === 0) {
    return safeTerm.split(/\s+/).filter(Boolean).map((word) => ({
      text: word,
      highlight: false,
    }));
  }

  const lowerQuery = safeQuery.toLocaleLowerCase();

  return safeTerm.split(/\s+/).filter(Boolean).map((word) => ({
    text: word,
    highlight: word.toLocaleLowerCase().startsWith(lowerQuery),
  }));
}